// Dependencies
import camelCase from 'lodash/camelCase'

// Utils
import { getCssClasses } from './renderless-composition.js';

// Flex prop validator
const validFlexProp = ([name, value]) => Boolean(value);

// Match flex prop with proper flex class
const mapFlexClassName = (cssClasses) => ([flexName, flexValue]) => cssClasses[`pcc__flex__${flexName + '_' + camelCase(flexValue)}`];

/**
 * Map proper flex classes based on props
 * @param {VNode} context - vNode functional component instance
 * @return {Array.<String>} - Array of proper flex classes
 */
const getFlexClasses = (context) => {
    const cssClasses = getCssClasses(context);
    return Object.entries(context.props)
    .filter(validFlexProp)
    .map(mapFlexClassName(cssClasses))
    .concat([ cssClasses.pcc__flex ]);
};

export {
    getFlexClasses
}